'use client';

import { useEffect, useState } from 'react';
import { apiClient } from '@/lib/api';
import type { DeliveryPoint } from '@/lib/api/delivery';
import { TechnicalBreakModal } from './technical-break-modal';

/**
 * Глобальная проверка технического перерыва при входе на сайт.
 * Запрашивает все точки доставки и если все активные на перерыве — показывает модалку.
 */
export function TechnicalBreakGuard() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const points = await apiClient.get<DeliveryPoint[]>('/delivery-points');
        const activePoints = points.filter((p) => p.is_active);
        if (activePoints.length === 0) return;

        const allOnBreak = activePoints.every((p) => p.technical_break);
        if (!cancelled) setShowModal(allOnBreak);
      } catch {
        // Не блокируем пользователя при ошибке сети
      }
    };

    check();
    return () => { cancelled = true; };
  }, []);

  return (
    <TechnicalBreakModal
      isOpen={showModal}
      onClose={() => setShowModal(false)}
    />
  );
}
